<template>
    <div>
      <div class="w-100 h-100">
        <Nav :rolname="rolname" />
      </div>
      <div class="content">
        <Home v-if="page=='home'" @mtdChangePage="mtdChangePage" @mtdBackCampus="mtdBackCampus" />
        <Seguimiento v-if="page=='seguimiento'" @mtdChangePage="mtdChangePage" :stateRolAdmin="stateRolAdmin" />
      </div>
      <div class="footer">
        <Footer @mtdChangePage="mtdChangePage" />
      </div>
    </div>
</template>
  
  <script>
    import { mapActions } from 'vuex'
    import Nav from '../../components/Vigilancia/Nav.vue'
    import Home from '../../components/Vigilancia/Home.vue'
    import Seguimiento from '../../components/Vigilancia/Seguimiento.vue'
    import Footer from '../../components/Vigilancia/Footer.vue'

    export default {
      name: "CallView",
      components: {
        Nav,
        Home,
        Seguimiento,
        Footer,
      },
      data () {
        return {
          prefix: 'call',
          page:'home',
          rol_name: null,
          stateRolAdmin: false,
        }
      },
      props: {
        rolname: String,
        dataRoles: Array
      },
      created () {
        this.rol_name = this.rolname;
        this.mtdGetRolAdmin();
      },
      methods: {
        ...mapActions(['get', 'post']),
        mtdChangePage: function(page, reserId, date, serId, patientId,hour){
          if (page === 'reprogramar') {
              this.reserId = reserId;
              this.date = date;
              this.serId = serId;
              this.patientId = patientId;
              this.page = page;
              this.hour = hour;
          }
          if(page !== 'reprogramar'){
            this.page = page;
          }
        },
        mtdBackCampus: function () {
              this.$emit("mtdBackCampus");
          },
        mtdGetRolAdmin:function(){
          this.dataRoles.forEach(element => {
            if(element.role_id==1){
              this.stateRolAdmin = true;
            }
          });
        },
        
      }
      
    }
  </script>